var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1"
      }
    },
    [
      _c("title", [_vm._v("icons/car-speed@1x")]),
      _vm._v(" "),
      _c("defs", [
        _c("path", {
          attrs: {
            d:
              "M16.0983748,18.6481972 C16.6010356,18.6481972 17.0079958,19.0551574 17.0079958,19.5578183 C17.0079958,20.05955 16.6010356,20.4674393 16.0983748,20.4674393 L16.0983748,20.4674393 L7.90063581,20.4674393 C7.39890408,20.4674393 6.9919439,20.05955 6.9919439,19.5578183 C6.9919439,19.0551574 7.39890408,18.6481972 7.90063581,18.6481972 L7.90063581,18.6481972 Z M19.0733652,6.92467787 C22.4424009,10.2937135 22.9655026,15.6092825 20.3156158,19.5627427 C20.1400097,19.823829 19.8519785,19.9651694 19.5593017,19.9651694 C19.3846247,19.9651694 19.2090186,19.9158131 19.0538534,19.8117503 C18.6366728,19.5320813 18.5251768,18.9671685 18.8048458,18.5499879 C19.4814234,17.5397671 19.9053691,16.4212754 20.0836635,15.2768854 L20.1297892,14.9328738 L19.274987,14.9328738 C18.7732553,14.9328738 18.365366,14.5249844 18.365366,14.0232527 C18.365366,13.5564962 18.7170665,13.1722571 19.1690239,13.1197472 L19.274987,13.1136317 L20.1325766,13.1136317 C19.979867,11.7116366 19.4674455,10.346494 18.6094465,9.17145041 L18.4053187,8.90373081 L17.7874454,9.52160414 C17.609981,9.69906851 17.3767686,9.78826526 17.1444854,9.78826526 C16.9112731,9.78826526 16.6789899,9.69906851 16.5015255,9.52253327 C16.1753225,9.19633022 16.1481389,8.68509424 16.4192591,8.32876803 L16.5005964,8.2356843 L17.1221863,7.61502357 C15.979021,6.69617756 14.6451845,6.12983318 13.2664841,5.91599041 L12.9475924,5.87289951 L12.9475924,6.72305605 C12.9475924,7.22571691 12.5406323,7.63267709 12.0379714,7.63267709 C11.5712149,7.63267709 11.1869758,7.28177775 11.1344659,6.82919085 L11.1283504,6.72305605 L11.1283504,5.86453731 C9.71859038,6.01379586 8.34087601,6.52757314 7.14845388,7.40512521 L6.87663851,7.61409443 L7.49822838,8.2356843 C7.85315712,8.59061304 7.85315712,9.1666754 7.49822838,9.52160414 C7.32076401,9.69906851 7.0884808,9.78826526 6.85526846,9.78826526 C6.66169912,9.78826526 6.46748455,9.72632307 6.30542399,9.60297639 L6.21230854,9.52160414 L5.59350607,8.90280167 C4.68328773,10.0485552 4.11675846,11.3945937 3.90805268,12.7906463 L3.86624814,13.1136317 L4.72476687,13.1136317 C5.2264986,13.1136317 5.63438792,13.5205918 5.63438792,14.0232527 C5.63438792,14.4891465 5.28268744,14.8741251 4.83073,14.926745 L4.72476687,14.9328738 L3.86903553,14.9328738 C4.01212199,16.1964944 4.45067269,17.438745 5.19490809,18.5499879 C5.47457707,18.9671685 5.36308113,19.5320813 4.94497135,19.8117503 C4.52779071,20.0904901 3.96287795,19.9789942 3.6841381,19.5618135 C1.0351804,15.6092825 1.55735305,10.2946427 4.92453043,6.92467787 C8.82688833,3.02510738 15.1737947,3.02510738 19.0733652,6.92467787 Z M15.9615135,10.3987984 C16.2868649,10.7241498 16.3139775,11.2353148 16.0428514,11.5916351 L15.9615135,11.6847183 L13.3683038,14.277928 C13.3989652,14.4061484 13.4156896,14.5399435 13.4156896,14.6774551 C13.4156896,15.6335328 12.6380054,16.4102879 11.6828568,16.4102879 C10.7277083,16.4102879 9.95095323,15.6335328 9.95095323,14.6774551 C9.95095323,13.7223066 10.7277083,12.9455515 11.6828568,12.9455515 C11.7745313,12.9455515 11.8645539,12.9525717 11.9523742,12.9663366 L12.0823839,12.9920082 L14.6755937,10.3987984 C15.0305224,10.0438697 15.6065848,10.0438697 15.9615135,10.3987984 Z",
            id: "path-1"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-1436.000000, -315.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "icons/car-speed",
                    transform: "translate(1436.000000, 315.000000)"
                  }
                },
                [
                  _c("rect", {
                    staticStyle: { "mix-blend-mode": "color-burn" },
                    attrs: {
                      id: "Rectangle",
                      "fill-opacity": "0.01",
                      x: "0",
                      y: "0",
                      width: "24",
                      height: "24"
                    }
                  }),
                  _vm._v(" "),
                  _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                    _c("use", { attrs: { "xlink:href": "#path-1" } })
                  ]),
                  _vm._v(" "),
                  _c("use", {
                    attrs: {
                      id: "Mask",
                      fill: "white",
                      "xlink:href": "#path-1"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }